/* Model */
class GroupModel extends App.Models.BaseModel {
    modelUrl = 'Group';
}

App.Models.Group = GroupModel;

/* Collection */
class GroupCollection extends App.Collections.BaseCollection {
    url = 'Group';
    model = App.Models.Group;
}

App.Collections.Groups = GroupCollection;
